import React from "react";
import EventLabel from "../../../components/EventLabel";

//pepetest

export const OrderTotalSummary = ({ flatOrderRows, environment, events, orders, breakouts, mainEvent }) => {
const isVatExempt = (orderRow) => {
  const targetBreakout = orderRow?.eventId === mainEvent?.eventId ? mainEvent : breakouts?.find((b) => b.eventId === orderRow?.eventId);
  const order = orders?.find((a) => a.leader) || orders?.[0];
  if (!order?.["orderExtra"] || !targetBreakout?.allowReverseCharge) return false;
  if (order["orderExtra"].some((a) => a.name == "vatExempt") && order["orderExtra"].some((a) => a.name == "sweVat")) return true;
  return order["orderExtra"].find((a) => a.name == "vatExempt")?.value;
};

  const calcTotalExVat = () => {
    var totalExVat = 0;
    flatOrderRows.map((or) => {
      totalExVat += or.amount - or.discountAmount;
    });
    return totalExVat;
  };
  const calcTotalVat = () => {
    var totalVat = 0;
    flatOrderRows.map((or) => {
      totalVat += or.vatAmount;
    });
    return totalVat;
  };
  const calcTotalSum = () => {
    var rowTotal = 0;
    flatOrderRows.map((or) => {
      rowTotal += isVatExempt(or) ? or.amount - or.discountAmount : or.rowTotal;
    });
    return rowTotal;
  };
  return (
    <div className="cms-order-total-container">
      <div className="cms-table ">
        <div className="cms-table-container">
          <table className="cms-table small">
            <thead>
              <tr>
                <th>
                  <EventLabel name="SummaryHeader" groupName="CMS.OrderSummary" />
                </th>
                <th>
                  <EventLabel name="SummaryAmount" groupName="CMS.OrderSummary" />
                </th>
              </tr>
            </thead>
            <tbody>
              {Math.round(calcTotalVat(), 2) > 0 ? (
                <>
                  <tr>
                    <td style={{ textAlign: "right" }}>
                      <EventLabel name="TotalExVat" groupName="CMS.OrderSummary" />
                    </td>
                    <td align="right" style={{ textAlign: "right" }}>
                      {Math.round(calcTotalExVat(), 2)}
                      {` ${environment.currency}`}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }}>
                      <EventLabel name="TotalVat" groupName="CMS.OrderSummary" />
                    </td>
                    <td align="right" style={{ textAlign: "right" }}>
                      {Math.round(calcTotalVat(), 2)}
                      {` ${environment.currency}`}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "right" }}>
                      <EventLabel name="TotalIncVat" groupName="CMS.OrderSummary" />
                    </td>
                    <td align="right" style={{ textAlign: "right" }}>
                      {Math.round(calcTotalSum(), 2)}
                      {` ${environment.currency}`}
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td align="right" style={{ textAlign: "right" }}>
                    <EventLabel name="TotalNoVat" groupName="CMS.OrderSummary" />
                  </td>
                  <td align="right" style={{ textAlign: "right" }}>
                    {Math.round(calcTotalSum(), 2)}
                    {` ${environment.currency}`}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
